export default "__VITE_ASSET__a4ee6c9f__"